import React, { useEffect } from "react";
import { BarChart3 } from "lucide-react";
import { PanelModal, PanelModalContent, PanelModalHeaderActions, panelModalSizeClasses, usePanelModalExpand } from "@/components/ui/panel-modal";
import AgentDayCallAnalysisView from "@/components/reports/AgentDayCallAnalysisView";

const AgentDayCallAnalysisModal = ({ isOpen, onClose, data, loading, isDark, textClass, labelClass }) => {
  const { expanded, setExpanded, toggleExpanded } = usePanelModalExpand(true);

  useEffect(() => {
    if (isOpen) setExpanded(true);
  }, [isOpen, setExpanded]);

  if (!isOpen) return null;

  return (
    <PanelModal open onClose={onClose}>
      <PanelModalContent
        className={`w-full flex flex-col rounded-xl shadow-2xl overflow-hidden ${panelModalSizeClasses(expanded, "max")} ${isDark ? "bg-slate-900 border border-slate-800" : "bg-white border border-gray-200"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`shrink-0 flex items-center justify-between gap-2 px-4 py-3 border-b ${isDark ? "border-slate-800 bg-slate-900" : "border-gray-200 bg-white"}`}>
          <div className="min-w-0">
            <h3 className={`text-base sm:text-lg font-semibold truncate ${textClass}`}>
              <BarChart3 className="w-5 h-5 inline mr-2 text-teal-500" />
              {data?.agent_name || "Agent"} — Çağrı Analizi
            </h3>
            {data?.date && (
              <p className={`text-xs mt-0.5 ${labelClass}`}>{data.date} · numara bazlı günlük analiz</p>
            )}
          </div>
          <PanelModalHeaderActions expanded={expanded} onToggle={toggleExpanded} onClose={onClose} isDark={isDark} />
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <AgentDayCallAnalysisView
            data={data}
            loading={loading}
            isDark={isDark}
            labelClass={labelClass}
            tableExpanded={expanded}
          />
        </div>
      </PanelModalContent>
    </PanelModal>
  );
};

export default AgentDayCallAnalysisModal;
